if (typeof jQuery !== "undefined") {
    $(document).ready(function () {
        // Quitar cache
        $.ajaxSetup({ cache: false });

        // Se cargan las acciones
        LoadBasic.init();

    });
}